import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=1bfe6c82&scoped=true&"
import script from "./newsDetails.vue?vue&type=script&lang=js&"
export * from "./newsDetails.vue?vue&type=script&lang=js&"
import style0 from "./newsDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newsDetails.vue?vue&type=style&index=1&id=1bfe6c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe6c82",
  null
  
)

export default component.exports